<div class="relative bg-gray-50">
  <div class="flex max-w-5xl flex-col bg-white lg:m-auto">
    <img
      [src]="
        impactReportData?.trip?.imagePath
          ? getImageUrl(impactReportData?.trip?.imagePath)
          : '/assets/create_account.jpg'
      "
      [alt]="impactReportData?.trip?.title"
      class="report-image h-60 w-full object-cover"
    />
    <div id="pdf-content" class="flex flex-col px-16">
      <app-page-header [title]="'impactReport.title' | transloco" />
      @if (impactReportData?.trip) {
        <header class="pb-12">
          <div class="flex justify-end gap-4">
            <p-selectbutton
              [options]="stateOptions"
              [(ngModel)]="value"
              optionLabel="label"
              optionValue="value"
              aria-labelledby="basic"
              (onChange)="onStateChange($event.value)"
            >
              <ng-template let-option pTemplate="item">
                {{
                  option.value === "kgCO2e"
                    ? ("impactReport.kgCO2e" | transloco)
                    : ("impactReport.percentage" | transloco)
                }}
              </ng-template>
            </p-selectbutton>
            <app-export-pdf> </app-export-pdf>

            <!-- Forum compensation button -->
            @if (impactReportData?.trip) {
              <p-button
                label="{{ 'forum.button.compensate' | transloco }}"
                icon="pi pi-heart"
                iconPos="left"
                (onClick)="openForumModal()"
                severity="primary"
                [outlined]="false"
                class="forum-compensate-btn"
                data-testid="forum-compensate-button"
              ></p-button>
            }

            <p-button
              label="{{ 'impactReport.backToCalculator' | transloco }}"
              icon="pi pi-angle-left"
              iconPos="left"
              (onClick)="redirectToCalculator()"
              severity="secondary"
              data-testid="back-to-calculator-button"
            ></p-button>
          </div>

          <!-- Travellers -->
          <div class="report-section flex flex-col gap-2 py-2 text-primary-500">
            <div>
              <h1
                id="report-title"
                class="shrink-1 mb-4 self-center text-5xl font-bold tracking-wide text-primary-500"
              >
                {{ impactReportData!.trip.title! }}
              </h1>
            </div>
            <div class="flex gap-8">
              <div class="flex items-center gap-2">
                <i class="pi pi-user !text-xl"></i>
                <div class="items-center">
                  {{
                    impactReportData!.trip.travellers +
                      " " +
                      ("travelBoards.travellers" | transloco).toLowerCase()
                  }}
                </div>
              </div>

              <!-- Days -->
              <div class="flex flex-row items-center gap-2">
                <i class="pi pi-calendar !text-xl"></i>
                <div class="items-center">
                  {{
                    impactReportData!.trip.days +
                      " " +
                      ("travelBoards.days" | transloco).toLowerCase()
                  }}
                </div>
              </div>

              <!-- Country -->
              <div class="flex items-center gap-2">
                <i class="pi pi-map-marker !text-xl"></i>
                <div class="items-center">
                  {{ impactReportData!.countryName }}
                </div>
              </div>
            </div>
          </div>
        </header>
      }

      <div class="mb-4 flex items-center gap-4">
        <span class="font-semibold text-primary-500">
          {{ "impactReport.overviewMode.title" | transloco }}
        </span>
        <p-selectbutton
          [options]="[
            {
              label: ('impactReport.overviewMode.detailed' | transloco),
              value: 'detailed',
            },
            {
              label: ('impactReport.overviewMode.mainVsOnSite' | transloco),
              value: 'mainVsOnSite',
            },
          ]"
          [(ngModel)]="overviewMode"
          optionLabel="label"
          optionValue="value"
          aria-labelledby="overview-mode"
          class="mr-4"
          (onChange)="setOverviewMode($event.value)"
        ></p-selectbutton>
        <p-checkbox
          [(ngModel)]="removeMainTransport"
          [binary]="true"
          inputId="removeMainTransport"
          class="mr-2"
        ></p-checkbox>
        <label for="removeMainTransport" class="text-gray-500">
          {{ "impactReport.overviewMode.noMainTransport" | transloco }}
        </label>
      </div>
      <h1>
        <h1
          class="shrink-1 mb-8 self-center text-xl tracking-wider text-primary-500 md:text-3xl"
        >
          {{ ("impactReport.title" | transloco).toLocaleUpperCase() }}
        </h1>
      </h1>

      @if (showPage) {
        @if (impactReportData?.overview) {
          <app-custom-pie-chart
            [title]="'impactReport.overview' | transloco"
            [data]="overviewChartDataGetter"
            position="right"
            [class.report-section]="graphService.graphOptions['overview']"
            [rowDirectionReverse]="false"
            [isPercentage]="isPercentage"
          />
        }
        @if (
          removeMainTransport && impactReportData?.overviewWithoutTransport
        ) {
          <app-custom-pie-chart
            [title]="'impactReport.overviewWithoutTransport' | transloco"
            [data]="impactReportData?.overviewWithoutTransport"
            position="right"
            [class.report-section]="
              graphService.graphOptions['overviewWithoutTransport']
            "
            [rowDirectionReverse]="false"
            [isPercentage]="isPercentage"
          />
        }
        @if (impactReportData?.overviewPerTraveller !== undefined) {
          <app-custom-pie-chart
            [title]="'impactReport.impactPerTraveller' | transloco"
            [data]="overviewPerTravellerChartDataGetter"
            position="left"
            [firstLine]="'impactReport.perTraveller' | transloco"
            [class.report-section]="graphService.graphOptions['perTraveller']"
            [rowDirectionReverse]="true"
            [isPercentage]="isPercentage"
          />
        }
        @if (displayPieChart(impactReportData?.transportDetail)) {
          <app-custom-pie-chart
            [title]="'impactReport.transportDetails' | transloco"
            [data]="impactReportData?.transportDetail"
            position="right"
            [class.report-section]="
              graphService.graphOptions['transportDetail']
            "
            [rowDirectionReverse]="false"
            [isPercentage]="isPercentage"
            [isTransportDistance]="isTransportDistance"
            [transportDistanceData]="transportKmChartData"
          />
        }
        @if (displayPieChart(impactReportData?.accommodationDetail)) {
          <app-custom-pie-chart
            [title]="'impactReport.accommodationDetails' | transloco"
            [data]="impactReportData?.accommodationDetail"
            position="left"
            [class.report-section]="
              graphService.graphOptions['accommodationDetail']
            "
            [rowDirectionReverse]="true"
            [isPercentage]="isPercentage"
          />
        }
        @if (displayPieChart(impactReportData?.activityDetail)) {
          <app-custom-pie-chart
            [title]="'impactReport.activityDetails' | transloco"
            [data]="impactReportData?.activityDetail"
            position="right"
            [class.report-section]="graphService.graphOptions['activityDetail']"
            [rowDirectionReverse]="false"
            [isPercentage]="isPercentage"
          />
        }
        @if (displayPieChart(impactReportData?.foodDetail)) {
          <app-custom-pie-chart
            [title]="'impactReport.foodDetails' | transloco"
            [data]="impactReportData?.foodDetail"
            position="left"
            [class.report-section]="graphService.graphOptions['foodDetail']"
            [rowDirectionReverse]="true"
            [isPercentage]="isPercentage"
          />
        }
        <app-impact-per-day-graph />
        @if (impactReportData?.carbonIntensity) {
          <app-carbon-intensity
            [carbonIntensity]="impactReportData?.carbonIntensity || 0"
            [class.report-section]="graphService.graphOptions['carbonDetail']"
          />
        }
        @if (impactReportData?.annualBudget !== undefined) {
          <app-annual-budget
            [annualBudget]="impactReportData?.annualBudget || 0"
            [impactPerTraveller]="impactReportData?.overviewPerTraveller?.total"
            [class.report-section]="graphService.graphOptions['annualDetail']"
          />
        }
        @if (impactReportData?.overviewPerTraveller !== undefined) {
          <app-carbon-equivalence
            [impactPerTraveller]="impactReportData?.overviewPerTraveller?.total"
            [class.report-section]="graphService.graphOptions['comparisons']"
          />
        }
      }
    </div>
  </div>
</div>
